import React from "react";
import Slider from "react-slick";
import { Grid, Box, Typography, Button } from "@mui/material";
import mobile from "../images/slide1.png";
import googleplay from "../images/google-play.png";
// import { Fade } from "react-reveal";

const carouselData = [
  {
    title: "Smart planning and Secure tomorrow",
    description:
      "Effective financial planning today lays the foundation for achieving your long-term goals and securing a brighter, more stable future.",
    image: mobile,
  },
  {
    title: "Track Your Expenses with Ease",
    description:
      "Monitor your spending habits and gain control over your finances with intuitive tools built for smarter decisions.",
    image: mobile,
  },
  {
    title: "Plan Investments for Growth",
    description:
      "Strategically invest for a better future using personalized insights and real-time tracking tools.",
    image: mobile,
  },
];

const sliderSettings = {
  dots: false,
  infinite: true,
  speed: 600,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 5000,
};

const ResponsiveSection = () => {
  return (
    <Box sx={{ py: 8, px: 2, color: "#FFF" }}>
      <Slider {...sliderSettings}>
        {carouselData.map((item, index) => (
          <Box key={index} sx={{ px: 2 }}>
            <Grid container alignItems="center" spacing={4}>
              {/* <Grid item xs={12} md={5} lg={6} sx={{ textAlign: "center" }}>
               
                  <img
                    src={item.image}
                    alt="Smart planning"
                    width="350"
                    style={{ maxWidth: "100%" }}
                    loading="lazy"
                  />
                
              </Grid> */}
              <Grid
                item
                xs={12}
                md={5}
                lg={6}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={item.image}
                  alt="Smart planning"
                  width="350"
                  style={{ maxWidth: "100%" }}
                  loading="lazy"
                />
              </Grid>

              <Grid item xs={12} md={7} lg={6} sx={{ textAlign: { xs: "center", md: "left" } }}>

                <Box>
                  <Typography
                    variant="h1"
                    sx={{
                      mb: 4,
                      fontWeight: "bold",
                      lineHeight: 1.2,
                      fontSize: { xs: "2rem", sm: "3rem", lg: "3rem" },
                    }}
                  >
                    {item.title.split(" ").slice(0, -1).join(" ")}{" "}
                    <Box
                      component="br"
                      sx={{
                        display: { xs: "block", lg: "none", xl: "block" },
                      }}
                    />
                    {item.title.split(" ").slice(-1)}
                  </Typography>

                  <Typography variant="body1" sx={{ fontSize: "1.25rem", mb: 4, mt: 3 }}>
                    {item.description}
                  </Typography>

                  <Grid container spacing={2} justifyContent={{ xs: "center", md: "flex-start" }}>
                    <Grid item xs={12} sm={6} md={4}>
                      <Button
                        component="a"
                        href="https://app.finkoda.com/login"
                        target="_blank"
                        rel="noopener noreferrer"
                        variant="contained"
                        size="large"
                        sx={{
                          borderRadius: "50px",
                          px: 5,
                          py: 1.5,
                          textTransform: "none",
                          fontSize: "1rem",
                          backgroundColor: "#1a7d3b",
                          "&:hover": {
                            backgroundColor: "#156e29",
                          },
                        }}
                      >
                        Try Now
                      </Button>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <Button
                        component="a"
                        href="https://play.google.com/store/apps/details?id=com.fastura.myfinanza&hl=en"
                        target="_blank"
                        sx={{ p: 0 }}
                      >
                        <Box component="img" src={googleplay} alt="Google Play" sx={{ width: 160 }} />
                      </Button>
                    </Grid>
                  </Grid>
                </Box>

              </Grid>
            </Grid>
          </Box>
        ))}
      </Slider>
    </Box>
  );
};

export default ResponsiveSection;
